<template src="./VehicleAddEdit.html">
  </template>

<script>
import { putVehicle, postVehicle, getVehicle } from '@/services/vehicle'
const mock = {
  plate_number: '',
  model_year: '',
  capacity: 0
}
export default {
  name: 'VehicleAddEdit',
  data () {
    return {
      model: mock,
      loading: false,
      isEditing: false
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.findVehicle(id)
    }
  },
  methods: {
    findVehicle (id) {
      getVehicle(id)
        .then(res => {
          this.model = res.data
          this.isEditing = true
        })
        .catch(err => {
          this.$message(err.response.data)
        })
    },
    handleCancel () {
      this.$router.push({ name: 'Vehicles' })
    },
    handleSave () {
      this.loading = true
      const httpRequest = this.isEditing ? putVehicle : postVehicle
      httpRequest(this.model)
        .then(res => {
          this.$message('Vehicle saved successfully')
          this.loading = false
          setTimeout(this.handleCancel, 1000)
          this.isEditing = false
          this.model = mock
        })
        .catch(err => {
          this.loading = false
          this.$message(err.response.data)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/vehicle/VehicleAddEdit.vue